<template>
  <div class="expertThinkTank">
    <comHead :tabIndexI="4" :imgSrc="imgSrc" />
    <div class="crumbsBg">
      <ul class="crumbs">
        <li class="address">
          <a class="interlinkage" href="../Home">首页&nbsp; </a>
        </li>
        <li class="address">></li>
        <li class="address">
          <a class="interlinkage" href="../information">资讯中心 </a>
        </li>
        <li class="address">></li>
        <li class="atPresent">文章详情</li>
      </ul>
    </div>
    <div class="textCenter">
      <h1 class="title">{{ entity.fTittle }}</h1>
      <div class="xiaozi">
        <div class="categoryLabels">{{ typeText }}</div>
        <div class="xiantiao"></div>
        <div class="time">鼎宏知识产权 {{ entity.fReleaseDate.split('T')[0] }}</div>
      </div>
      <div class="zhegnwen" v-html="entity.fContent"></div>
    </div>
    <!-- <ul class="previous">
      <li class="previousBox">
        <a href="" class="previousText">上一篇：你知道吗？影响专利价值评估的法律下一篇：你知道吗？影响专利价值评估的法律</a>
      </li>
      <li class="previousBox right">
        <a href="" class="previousText">下一篇：你知道吗？影响专利价值评估的法律下一篇：你知道吗？影响专利价值评估的法律</a>
      </li>
    </ul> -->
    <comFooter />
  </div>
</template>

<script>
import { getNewInfo } from "../request/api.js";
export default {
  data() {
    return {
      imgSrc: require("../../static/imgs/information/xiangqin.jpg"),
      id: this.$route.query.id,
      typeText: this.$route.query.typeText,
      entity: {
        fNewsId: 0,
        fTittle: '',
        fReleaseDate: '',
        fContent: ''
      }
    };
  },
  mounted() {
    getNewInfo({ fNewsId: this.id }).then(data => {
      if (data.StatusCode == 200) {
        data.Result.fContent = data.Result.fContent.replace(/\/Upload\/UEditor/g, this.$urlFile + "Upload/UEditor");
        this.entity = data.Result;
      } else
        console.log(data.Msg);
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

/deep/ .banner {
  height: 120px !important;
}

.expertThinkTank {
  background: #fff !important;

  .crumbsBg {
    background: #f7f7f7;
    padding: 1rem 0;

    .crumbs {
      display: flex;
      margin: 0 auto;
      max-width: 1200px;

      .address {
        font-size: 0.875rem;
        color: #999;
        margin: 0 0.2rem;
      }

      .interlinkage {
        font-size: 0.875rem;
        color: #999;
      }

      .interlinkage:hover {
        color: #0c56b0;
      }

      .atPresent {
        color: #0c56b0;
        font-size: 0.875rem;
        margin: 0 0.2rem;
      }
    }
  }

  .textCenter {
    margin: 0 auto;
    max-width: 880px;
    padding: 3.2rem 0 1rem 0;
    border-bottom: 0.0625px solid #f0f0f0;

    .title {
      font-size: 1.75rem;
      font-weight: bold;
      color: #333;
      margin-bottom: 1.2rem;
    }

    .xiaozi {
      display: flex;
      align-items: center;
      padding-bottom: 2.2rem;
      border-bottom: 0.0625px solid #f0f0f0;

      .categoryLabels {
        font-size: 0.875rem;
        color: #333;
      }

      .xiantiao {
        width: 0.06rem;
        height: 1rem;
        background: #ccc;
        margin: 0 1rem;
      }

      .time {
        font-size: 0.875rem;
        color: #999;
      }
    }

    .zhegnwen {
      font-size: 1rem;
      color: #666;
      padding: 2.2rem 0;
      line-height: 1.7rem;
    }

    .photo {
      max-width: 880px;

      img {
        display: block;
        margin: 0 auto;
        width: 90%;
      }
    }
  }

  .previous {
    margin: 0 auto;
    max-width: 880px;
    display: flex;
    justify-content: space-between;
    padding: 2rem 0 3.2rem 0;

    .previousBox {
      width: 40%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }

    .right {
      text-align: right;
    }

    .previousText {
      font-size: 1rem;
      color: #333;
    }

    .previousText:hover {
      color: #0c56b0;
    }
  }
}
@media screen and(max-width: 500px) {
	.expertThinkTank{
		width: 100vw;
		.textCenter{
			padding: 10px 5px 0 5px;
		}
	}
	}
</style>